import { EarthBrainViewerAPIs } from "./EarthBrainViewerAPIs";
export class AIRoadAPIs extends EarthBrainViewerAPIs {
    //AI road
    /**
     * Promise is resolved when user clicks on Finish Drawing context menu option.
     * The data contains array of following object :
     * { x: number, y: number, z: number, heightFromPointCloud: number, heightFromDesignData: number }
     * @returns Promise with AIRoadPreviewData
     */
    createAIRoadPreview() {
        return this._scDesign.createAIRoadPreview();
    }
    enableDragForAIRoadPreview() {
        this._scDesign.enableDragForAIRoadPreview();
    }
    updateAIRoadPreviewPointAtIndex(PointIndex, position) {
        this._scDesign.updateAIRoadPreviewPointAtIndex(PointIndex, position);
    }
    setAIRoadPreviewCallback(callback) {
        this._scDesign.setAIRoadPreviewCallback(callback);
    }
    removeAIRoadPreview() {
        this._scDesign.removeAIRoadPreview();
    }
    async pickPointsForRoadConstruction_AI(numberOfPointsToPick = 2, usePointCloudPriority = false) {
        return this._scDesign.pickPointsForRoadConstruction_AI(numberOfPointsToPick, usePointCloudPriority);
    }
    // --- 仮設道路AI 中継点ピック（連続選択・道路は生成しない）
    enableRoadAiPointPick(onFinish, maxPoints = 7, onLimitExceeded) {
        this._scDesign.enableRoadAiPointPick(onFinish, maxPoints, onLimitExceeded);
    }
    finishRoadAiPointPick() {
        this._scDesign.finishRoadAiPointPick();
    }
    undoRoadAiPointPick() {
        this._scDesign.undoRoadAiPointPick();
    }
    redoRoadAiPointPick() {
        this._scDesign.redoRoadAiPointPick();
    }
    cancelRoadAiPointPick() {
        this._scDesign.cancelRoadAiPointPick();
    }
    checkRoadAiPointPickUnderway() {
        return this._scDesign.checkRoadAiPointPickUnderway();
    }
}
//# sourceMappingURL=road-ai.js.map